import { sacredPath } from "./registry";
import { imageUrlForLibraryTopic } from "./image-urls";

/** Map hybrid pañchāṅga festival ids → sacred library festival ids */
export const PANCHANGA_FESTIVAL_TO_LIBRARY = {
  ugadi: "ugadi",
  rama_navami: "rama_navami",
  nrisimha_jayanti: "nrisimha_jayanti",
  janmashtami: "krishna_janmashtami",
  maha_shivaratri: "maha_shivaratri",
  navaratri_begin: "navaratri",
  vijayadashami: "vijayadashami",
  vinayaka_chaturthi: "ganesh_chaturthi",
  kartika_deepam: "kartika_deepam",
  vaikuntha_ekadashi: "vaikuntha_ekadashi",
};

/** Map pañchāṅga vrata ids → library vrata ids */
export const PANCHANGA_VRATA_TO_LIBRARY = {
  ekadashi: "ekadashi",
  pradosham: "pradosham",
  sankashti: "sankashti",
  purnima_vrata: "purnima",
  amavasya_vrata: "amavasya",
  monthly_shivaratri: "monthly_shivaratri",
};

export function libraryLinkForFestival(panchangaFestivalId) {
  const libId = PANCHANGA_FESTIVAL_TO_LIBRARY[panchangaFestivalId];
  return libId ? sacredPath("festival", libId) : null;
}

export function libraryLinkForVrata(panchangaVrataId) {
  const libId = PANCHANGA_VRATA_TO_LIBRARY[panchangaVrataId];
  return libId ? sacredPath("vrata", libId) : null;
}

/** Match festival by English name substring (fallback) */
export function libraryLinkForFestivalName(nameEn) {
  if (!nameEn) return null;
  const lower = nameEn.toLowerCase();
  if (lower.includes("ugadi") || lower.includes("yugadi")) return sacredPath("festival", "ugadi");
  if (lower.includes("rama navami") || lower.includes("rāma navam")) return sacredPath("festival", "rama_navami");
  if (lower.includes("nrisimha") || lower.includes("nṛsiṃha")) return sacredPath("festival", "nrisimha_jayanti");
  if (lower.includes("janmashtami") || lower.includes("janmāṣṭam")) return sacredPath("festival", "krishna_janmashtami");
  if (lower.includes("shivaratri") || lower.includes("śivarātri")) return sacredPath("festival", "maha_shivaratri");
  if (lower.includes("navaratri") || lower.includes("navarātri")) return sacredPath("festival", "navaratri");
  if (lower.includes("vijayadashami") || lower.includes("vijayādaśam")) return sacredPath("festival", "vijayadashami");
  if (lower.includes("ganesh") || lower.includes("vinayaka") || lower.includes("gaṇeśa"))
    return sacredPath("festival", "ganesh_chaturthi");
  if (lower.includes("kartika") || lower.includes("kārttika")) return sacredPath("festival", "kartika_deepam");
  if (lower.includes("vaikuntha") || lower.includes("vaikuṇṭha")) return sacredPath("festival", "vaikuntha_ekadashi");
  return null;
}

export function libraryImageForFestival(panchangaFestivalId) {
  const libId = PANCHANGA_FESTIVAL_TO_LIBRARY[panchangaFestivalId];
  return libId ? imageUrlForLibraryTopic("festivals", libId) : null;
}

export function libraryImageForVrata(panchangaVrataId) {
  const libId = PANCHANGA_VRATA_TO_LIBRARY[panchangaVrataId];
  return libId ? imageUrlForLibraryTopic("vratas", libId) : null;
}

export function libraryLinkForVrataName(nameEn) {
  if (!nameEn) return null;
  const lower = nameEn.toLowerCase();
  if (lower.includes("ekadashi") || lower.includes("ekādaśī")) return sacredPath("vrata", "ekadashi");
  if (lower.includes("pradosha") || lower.includes("pradoṣa")) return sacredPath("vrata", "pradosham");
  if (lower.includes("sankashti") || lower.includes("sankṣaṣṭi")) return sacredPath("vrata", "sankashti");
  if (lower.includes("purnima") || lower.includes("pūrṇim")) return sacredPath("vrata", "purnima");
  if (lower.includes("amavasya") || lower.includes("amāvasy")) return sacredPath("vrata", "amavasya");
  if (lower.includes("shivaratri") && lower.includes("monthly")) return sacredPath("vrata", "monthly_shivaratri");
  return null;
}
